export {hasProperty} from './lib/index.js'
